<p>
  pia3-reset-password component works!
</p>
